export default {
  menu: {
    index: '共通テンプレート',
    works: 'マイクリエイティブ',
    myTemplate: 'マイテンプレート',
    stars: 'お気に入り',
  },
  suggestionDialog: {
    title: '制作アドバイス',
    context:
      '· フリーエディターでは操作が制限されません。<br/>· ゲームの動作ロジックに関連するコアレイヤー/シーンを削除しないようにしてください。ロジックの異常が発生し、プレイアブル広告の正常な使用ができなくなる可能性があります。<br/>· 制作を完了したら、必ずプレビューで動作を確認してください。',
  },
  saveAsTemplate: {
    label: 'テンプレートとして保存',
    cancel: 'キャンセル',
    confirm: '確認',
    form: {
      nameLabel: 'テンプレート名',
      name: 'テンプレート名を入力してください',
      emptyName: 'テンプレート名を入力してください',
      overName: '名前は50文字以内で入力してください',
    },
    copy: 'コピー',
    rename: '名前の変更',
    success: 'テンプレートの保存が成功しました',
  },
  previewDialog: {
    next: '次へ',
    prev: '前へ',
    create: 'スキン制作',
    createTips:
      'プレイアブルテンプレートを基に、アセットの差し替え、サイズ調整、プレイ内容のパラメータ調整を行い、高品質なプレイアブル広告を素早く書き出せます。',
    free: 'コンテンツ制作',
    freeTips:
      'スキン制作に対応した操作に加え、レイアウトの変更、アセットの追加、イベントの編集など、テンプレートをさらに調整して多数のバリエーションを作成できます。',
    qrcodeLabel: 'モバイル表示',
    skinLabel: 'スキンの選択',
    difficulty: '難易度',
    modelCount: 'モデルの数',
    actionCount: 'アニメーションの数',
  },
  index: {
    listEmpty: '現在のリストは空です',
    listDesc:
      '条件に一致する結果が見つかりませんでした。異なる検索条件をお試しください。',
    saveListEmpty: 'お気に入りのテンプレートはありません',
    leaveMessage: {
      title: 'コメント',
      desc: '様々なテンプレートをお試しください',
    },
    checkall: 'すべてのテンプレートを表示',
    filters: {
      category: 'タイプ',
      classify: 'カテゴリ',
      industry: 'インダストリー',
      originality: '創造性',
      difficulty: '難易度',
      playMethod: 'メソッド',
      productType: 'プロダクト',
      all: 'すべて',
      new: '新着',
      hot: '人気',
      more: 'さらに展開',
      back: '閉じる',
    },
    list: {
      starButton: 'お気に入り',
      useTemplate: '作成',
      unsave: 'お気に入りを解除',
      saveSuccess: 'お気に入りに追加しました',
    },
    estimated: '制作時間',
    createFromBlank: '新規のキャンバス',
  },
  works: {
    listEmpty: '現在のリストは空です',
    dcoStatus: '未公開',
    listNormal:
      'プロジェクトがまだ作成されていません。適切なテンプレートを選択して作業を始めましょう！',
    listMgroup:
      'マルチコンビネーション制作は、効率的なバッチ制作方法であり、一度に複数の作品を製作し、ABテストを行うことができます。調整が必要な位置にアセットを追加し、すべての組み合わせの作品を一度にダウンロードできます（最大27の組み合わせ）。',
    listDCO:
      'DCO制作は、広告のスマートな配信能力をサポートする制作方法で、1つのパッケージから異なるコンテンツを表示できます。対応する位置に対してバリエーションのあるアセットを追加し、作品をSSにプッシュした後、Mintegralはアルゴリズムに従って各位置で最適なアセットを選択して組み合わせ、変換を向上させます。',
    infoTitle: 'マイクリエイティブ',
    infoContent:
      '同時に複数のコンビネーション制作とDCO制作をサポートし、迅速な作成およびスマートな広告配信を可能にします。',
    psMgroup:
      '簡単な「ドラッグアンドドロップ」のPPTスタイルの操作で、コードを一切必要とせず、画像、テキスト、音声、ビデオ、エフェクトを自由に組み合わせて、個性的なプレイアブル広告を制作できます。',
    ivMgroup:
      '専門的なスキルは不要。ビジュアルスクリプトを使い、動画のタイムラインにイベントを追加することで、簡単に通常の動画をインタラクティブな動画に変換し、迅速にインタラクティブなエフェクトを追加できます。',
    projectType: {
      normal: '通常の制作',
      normalEditor: 'スキンチェンジエディター',
      dco: 'DCO制作',
      mgroup: 'マルチコンビネーション制作',
      mgroupEditor: 'マルチコンビネーションスキンエディタ',
      ps: 'コンテンツエディタ',
      iv: '動画をプレイアブル化',
    },
    projectPlaceHolder: '作品名を入力してください',
    table: {
      column: {
        name: '作品',
        type: '作品の種類',
        template: 'テンプレート名',
        status: '制作の進捗',
      },
    },
    status: {
      all: 'すべての進捗',
      making: '制作中',
      downloaded: 'ダウンロード済み',
      reviewing: '審査中',
      pushed: 'プッシュ済み',
      pushFaild: 'プッシュ失敗',
      pending: 'プッシュ中',
      partSuccess: '一部プッシュ済み',
    },
    options: {
      edit: '編集',
      product: '製品情報の変更',
    },
  },
  myTemplate: {
    menu: {
      update: 'テンプレートの更新',
      copy: 'テンプレートのコピー',
      delete: 'テンプレートの削除',
      edit: 'テンプレート名の変更',
    },
    sort: {
      createdTimeNear: '作成時間（新しい順）',
      createdTimeFar: '作成時間（古い順）',
      updatedTimeNear: '更新時間（新しい順）',
      updatedTimeFar: '更新時間（古い順）',
    },
    sortOrder: {
      createdTime: '作成時間',
      updatedTimer: '更新時間',
    },
    status: {
      check: 'チェック待ち',
      unauthorized: '未承認',
    },
  },
  subscribe: {
    renew: '更新',
    expired: 'サブスクリプションの更新が必要',
    hasNotSubscribe: 'サブスクリプションサービスがまだ有効ではありません',
    timeLeft: '期限切れまで {{timeLeft}} 日',
    hasNotSubscribeAlertTitle:
      'サブスクリプションが開始されていません。今すぐお申し込みください！',
    expiredAlertTitle:
      'サブスクリプションが期限切れです。すぐに更新しましょう！',
    renewExpiredAlertTitle: '更新申請',
    alertDesc:
      '以下のフォームに記入してください。すぐに担当者よりご連絡いたします。',
    form: {
      name: {
        label: 'お名前',
        placeholder: 'お名前を入力してください',
      },
      email: {
        label: 'メールアドレス',
        placeholder: '受信用メールアドレスを入力してください',
      },
      month: {
        label: '購入期間',
        placeholder: '購入期間',
        optionTail: '月',
      },
      remark: {
        label: '備考',
        placeholder: 'その他の連絡先または備考',
      },
    },
    submitSuccess: {
      title: '購入申し込みが送信されました。お問い合わせありがとうございます。',
      desc: '他にご質問があれば、 <a href="mailto:support@mindworks-creative.com">support@mindworks-creative.com</a> までメールでお問い合わせください。',
    },
  },
  resetTemplate: {
    text: 'デフォルトに戻す',
    warnTitle: '全体をデフォルトに戻しますか？',
    warnDetail: 'すべての変更はデフォルト値に戻ります。',
  },
  versionEditTitle: 'プロジェクト情報の編集',
  creativeInfo: {
    action: {
      create: '作成',
      update: '更新',
      copy: 'コピー',
    },
    type: {
      create: {
        normal: 'スキン制作',
        mgroup: 'マルチコンビネーションスキンエディタ',
        dco: 'DCO制作',
        playsmart: 'コンテンツエディタ',
        createPlayable: '作品の作成',
        directCreate: '直接作成',
        psdCreate: 'PSDのインポート',
        iv: '動画をプレイアブル化',
      },
      copy: {
        normal: 'コピー',
        mgroup: '複数の組み合わせにコピー',
        dco: 'DCOにコピー',
        playsmart: 'コンテンツエディタにコピー',
        iv: 'インタラクティブビデオエディタにコピー',
      },
    },
    form: {
      versionName: {
        label: 'バージョン名',
        placeholder: 'バージョン名を入力してください',
        validateMessage:
          '数字、文字、アンダースコアのみがサポートされ、50文字以内である必要があります',
        empty: 'バージョン名は空白にできません',
      },
      name: {
        label: 'プロジェクト名',
        placeholderProject: 'プロジェクト名を入力してください',
        placeholder:
          '数字、文字、アンダースコアのみがサポートされ、50文字以内である必要があります',
        validateMessage:
          '数字、文字、アンダースコアのみがサポートされ、50文字以内である必要があります',
        empty: 'プロジェクト名は空白にできません',
      },
      promotedType: {
        label: '製品タイプ',
        empty: '製品タイプは空白にできません',
      },
      appInfo: '広告製品情報（CTAのリダイレクトおよび読み込みページ用）',
      appIcon: {
        label: '製品アイコン',
        tips: '提供されたストアのリンクに対応するアイコンを取得します',
      },
      appName: {
        label: '製品名',
        tips: '提供されたストアのリンクに対応する名前を取得します',
        empty: '製品名は空白にできません',
      },
      url: {
        label: 'リダイレクトURL',
        placeholder: 'URL。',
        empty: 'リダイレクトURLは空白にできません',
        valid: 'リダイレクトURLの形式が正しくありません',
      },
      iOSURL: {
        label: 'iOSのURL',
        placeholder: 'Apple App StoreのURL。',
        empty: 'リダイレクトURLは空白にできません',
      },
      androidURL: {
        label: 'AndroidのURL',
        placeholder: 'Google Play/Android App StoreのURL。',
        empty: 'リダイレクトURLは空白にできません',
      },
      platform: {
        label: 'プラットフォームの選択',
        empty: 'プラットフォームの選択は空白にできません',
      },
      direction: {
        label: '画面の向き',
        tips: 'Mintegralで出稿するには、横向きと縦向きの両方をサポートする必要があります',
        placeholder: '画面の向きを選択してください',
        options: {
          adaptive: {
            label: '横向きと縦向き',
            desc: '横向きと縦向きのレイアウト制作が必要で、投稿時には作成したページに従って表示されます',
            tips: 'Mintegralで出稿する場合、このオプションを選択することをお勧めします',
          },
          landscape: {
            label: '横向き',
            desc: '横向きのレイアウト制作のみが必要です。縦向きのアプリに投稿されると、横向きのサイズに合わせ縮小表示されます',
          },
          portrait: {
            label: '縦向き',
            desc: '縦向きのレイアウト制作のみが必要です。横向きのアプリに投稿されると、縦向きのサイズに合わせ縮小表示されます',
          },
          see: '，詳細は',
          help: 'ヘルプセンター',
        },
      },
      language: {
        label: '初期言語',
        placeholder: '初期言語を選択してください',
        empty: '初期言語は空白にできません',
      },
      quality: {
        label: '圧縮品質',
        title: '品質コントロール',
      },
      psd: {
        title: 'PSDのインポート（デフォルトで横向きと縦向きに適応）',
        uploadTip1:
          'ここにファイルをドラッグアンドドロップするか、クリックしてすぐにアップロードできます',
        uploadTip2: '単一ファイル：1つのPSDファイルを直接アップロード',
        uploadTip3:
          '横向きおよび縦向き：2つのpsdファイルをzipアーカイブにして、ファイルをルートディレクトリにアップロードします',
        uploadTip4:
          '圧縮画像：サイズは変更せず、数値が大きいほどファイルは大きくなります',
        uploading: 'アップロード中',
        error: 'アップロードに失敗しました。もう一度アップロードしてください',
        emptyError: 'psdファイルがありません',
        psdError: 'psdファイルが無効です',
        psdErrorName:
          'ファイル名は英数字およびアンダースコアである必要があります',
      },
      psd2uiErr: {
        firstLv: 'レイヤーの最初の階層はgameである必要があります',
        scenePlayGlobal:
          'gameレイヤーの下の最初の階層はxxx@scene、xxx@global、xxx@playの順である必要があります',
        zip: 'zipファイル内には2つのpsdファイルが含まれている必要があります',
        layerEmpty:
          '横向きと縦向きのpsd、少なくとも1つのレイヤーが空であるため、横向きと縦向きの差異を比較してください！ 縦向き: {layersPName}、横向き: {layersLName}',
        layerDiff:
          '横向きと縦向きのpsdのレイヤー名が異なるため、レイヤーを比較してください。縦向き: {layersPName}、横向き: {layersLName}',
        emptyImg:
          'レイヤーが正常に読み込まれていません。ピクセルのないレイヤーが存在します: {path}（このピクセルのないレイヤーを代わりに単色ブロックで置き換え、後で透明な画像で置き換えることをお勧めします）',
        rasterized:
          'レイヤー{path}をエクスポートするにはラスタライズする必要があります',
        validName:
          'zipファイル内のファイル名は英数字およびアンダースコアである必要があります',
      },
    },
  },
}
